import $ from 'jquery';
import {merge} from 'lodash';

import {EA_URI} from 'resources/InternalURIs';

// AJAX sync setup
const clearXSSPrefix = (content) => {
  // \s\S workaround for jsLint not liking "." in regex
  const isBinary = content instanceof ArrayBuffer || content instanceof Blob;

  if (isBinary) {
    return content;
  }

  return content ? content.replace(/^[\s\S]*&&&NOXSS&&&/, '') : content;
};

const getOptionsUrl = (originalUrl) =>
  window.location.origin +
  (/^\//.test(originalUrl) ? originalUrl : `/${originalUrl}`);

const createBeforeSend = ({
  options,
  originalOptions,
  csrfToken,
  jsonWebToken,
  ipimsUserId,
  consoleSessionId,
  orgId,
}) => (xhr) => {
  options.url = !originalOptions.crossDomain
    ? getOptionsUrl(originalOptions.url)
    : originalOptions.url;

  if (originalOptions.headers) {
    for (const header in originalOptions.headers) {
      xhr.setRequestHeader(header, originalOptions.headers[header]);
    }
  }

  if (!originalOptions.crossDomain || originalOptions.console) {
    xhr.setRequestHeader('CSRFToken', csrfToken);
  }

  if (
    originalOptions.crossDomain &&
    originalOptions.console &&
    consoleSessionId
  ) {
    xhr.setRequestHeader('nexposeCCSessionID', consoleSessionId);
  }

  if (jsonWebToken) {
    xhr.setRequestHeader('X-AUTH-TOKEN', jsonWebToken);
    xhr.setRequestHeader('Authorization', jsonWebToken);
    xhr.setRequestHeader('X-NO-CSRF', 'X-NO-CSRF');
  }

  if (options.url.indexOf(EA_URI.AUTOMATION_API) > -1 && ipimsUserId) {
    xhr.setRequestHeader('X-IPIMS-USER-ID', ipimsUserId);
    xhr.setRequestHeader('X-IPIMS-ORG-ID', orgId);
  }
};

function init({
  consoleSessionId,
  csrfToken,
  withCredentials = false,
  jsonWebToken,
  ipimsUserId,
  orgId,
}) {
  // General rewrite for all $.ajax requests (includes .fetch())
  $.ajaxPrefilter((options, originalOptions) => {
    merge(
      options,
      {
        dataFilter(data) {
          return clearXSSPrefix(data);
        },
        error(xhr, textStatus, errorThrown) {
          // Order of jquery callback hooks is: 1) beforeSend, 2) error, 3) dataFilter, 4) success,
          // 5) jqXhr promise callback, 6) complete.  We need to remove the NO-XSS prefix on the error call back
          // because the data-filter won't be run
          xhr.responseText = clearXSSPrefix(xhr.responseText);
          if (originalOptions.error) {
            originalOptions.error(xhr, textStatus, errorThrown);
          }
        },
      },
      {
        beforeSend:
          originalOptions.beforeSend ||
          options.beforeSend ||
          createBeforeSend({
            consoleSessionId,
            csrfToken,
            ipimsUserId,
            jsonWebToken,
            options,
            orgId,
            originalOptions,
          }),
      },
      {
        xhrFields: {
          withCredentials: options.xhrFields || withCredentials,
        },
      }
    );
  });
}

export default {
  getOptionsUrl,
  init,
};
